// v2/router/FeatureFlagRedirect.tsx — Conditional redirect from v1 to v2 based on feature flags

import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { configurationService } from '../config';

export interface FeatureFlagRedirectProps {
  /** Feature flag name to check (e.g., 'leads', 'applications') */
  featureName: string;
  /** The v2 path to redirect to when the flag is enabled */
  v2Path: string;
  /** The v1 page component to render when the flag is disabled */
  children: ReactNode;
}

/**
 * When the feature flag is enabled, redirects to the v2 path.
 * When disabled, renders the v1 children (existing page).
 */
export function FeatureFlagRedirect({
  featureName,
  v2Path,
  children,
}: FeatureFlagRedirectProps): React.ReactElement {
  if (configurationService.isFeatureEnabled(featureName)) {
    return <Navigate to={v2Path} replace />;
  }

  return <>{children}</>;
}
